import { useState } from "react";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Sections from "./components/Sections";
import Team from "./components/Team";
import Contact from "./pages/Contact";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

function App() {
  const [currentColor, setCurrentColor] = useState("green");

  return (
    <Router>
      <Routes>
        <Route
          path="/join"
          element={
            <div>
              <Header setCurrentColor={setCurrentColor} />
              <Contact color={currentColor} />
              <Footer color={currentColor} />
              <div id="contact"></div>
            </div>
          }
        />
        <Route
          path="/"
          element={
            <div className="overflow-x-hidden">
              <Header setCurrentColor={setCurrentColor} />
              <Hero color={currentColor} />
              <Sections color={currentColor} />
              <Team color={currentColor} />
              <Footer color={currentColor} />
              <div id="contact"></div>
            </div>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
